import { useAuth } from "@clerk/clerk-react";
import { useCallback, useEffect, useState } from "react";
import {
	clearLicenseCache,
	fetchLicenseState,
	isPremium,
	type LicenseState,
} from "./license";

interface UseLicenseReturn {
	license: LicenseState | null;
	isLoading: boolean;
	isPro: boolean;
	portalUrl: string | null;
	refresh: () => Promise<void>;
}

export function useLicense(): UseLicenseReturn {
	const { getToken, isSignedIn } = useAuth();
	const [license, setLicense] = useState<LicenseState | null>(null);
	const [isLoading, setIsLoading] = useState(false);

	const refresh = useCallback(async () => {
		setIsLoading(true);
		try {
			const authToken = isSignedIn ? await getToken() : null;
			const state = await fetchLicenseState({ authToken });
			setLicense(state);
		} finally {
			setIsLoading(false);
		}
	}, [getToken, isSignedIn]);

	useEffect(() => {
		if (isSignedIn === undefined) return; // Clerk初期化待ち
		clearLicenseCache(); // 認証状態変化時に古いキャッシュをクリア
		refresh();
	}, [isSignedIn, refresh]);

	return {
		license,
		isLoading,
		isPro: isPremium(license),
		portalUrl: license?.portal_url ?? null,
		refresh,
	};
}
